import { RestoreAddressForm } from "@/components/forms/RestoreAddress"
import { EditAddressScreen } from "@/components/screens/settings/EditAddressScreen"
import { useToast } from "@/hooks/use-toast"
import { useUpdateAndRegenerateReport } from "@/queries/useReport"

import { useNavigate } from "@/router"
import { restoreAddressesWithAi } from "@/solver/onboard-algo"
import { hqAddressDraftAtom } from "@/state/draft/hqAddress"
import { currentAuthAtom } from "@/state/auth"
import { useAnalytics } from "@/hooks/use-analytics"
import { useAtom, useAtomValue } from "jotai"
import React from "react"
import { reportFormDraftAtom } from "@/state/report"
import { addressesDraftAtom } from "@/state/draft/addresses"

export default function EditAddressPage() {
	const navigate = useNavigate()
	const auth = useAtomValue(currentAuthAtom)
	const form = useAtomValue(reportFormDraftAtom)
	const [clients, setAddr] = useAtom(addressesDraftAtom)
	const [hqAddr, setHqAddr] = useAtom(hqAddressDraftAtom)
	const { run, generating } = useUpdateAndRegenerateReport()

	const { toast } = useToast()
	const { sendEvent } = useAnalytics("Edit_Address")

	React.useEffect(() => {
		sendEvent("Step_Addresses_View")
	}, [])

	const handleRestoreAddress = async (data: RestoreAddressForm) => {
		// TODO: add addresses calculation
		const addressesCount = Math.min(data.count * 10, 3000)
		const radiusMiles = data.radiusMiles
		try {
			const addresses = await restoreAddressesWithAi(
				data.address,
				addressesCount,
				radiusMiles
			)
			return addresses.slice(0, data.count)
		} catch (e) {
			toast({
				title: "Error",
				description: "Failed to restore addresses",
				variant: "destructive",
			})
			console.error("Error restoring addresses", e)
			return []
		}
	}
	return (
		<EditAddressScreen
			reportId={auth.reportId}
			clientAddresses={clients}
			hqAddress={hqAddr}
			onSave={(data) => {
				setAddr(data.clients)
				setHqAddr(data.hq)
				sendEvent("Step_Addresses__Save")
				run(form)
			}}
			onSaveLocal={(data) => {
				setAddr(data.clients)
				setHqAddr(data.hq)
			}}
			savingInProcess={generating}
			restoreAddresses={handleRestoreAddress}
		/>
	)
}
